import Skeleton from "@mui/material/Skeleton";
import { L } from 'harmony-language';
import React from 'react';
import { QueryKeys } from '../../../../api/config';
import { useStaticQuery } from '../../../../api/queries/use-static-query';
import { Driver, getTransUserRole, LoadingTeamMember, SiteManager } from '../../../../constants/constants';
import { Role } from '../../../../types';
import { createAgisticsSelectElements } from '../../../shared/agistics-select';
import { AgisticsMultiSelect } from '../../../shared/multi-select/agistics-multi-select';

interface SelectUserRoles {
    roles: Role[] | undefined;
    onChange: (roles: Role[]) => void;
}

export const SelectUserRoles = (props: SelectUserRoles) => {
    const { roles, onChange } = props;
    const { data: allAvailableRoles = [], isLoading } = useStaticQuery<Role[]>(QueryKeys.roles);

    const isOptionDisabled = (optionId: number) => {
        if (optionId === Driver.id) {
            return roles?.some(r => r.id === SiteManager.id || r.id === LoadingTeamMember.id) || false;
        }
        if (optionId === SiteManager.id || optionId === LoadingTeamMember.id) {
            return roles?.some(r => r.id === Driver.id) || false;
        }
        return false;
    };

    return isLoading ? (
        <Skeleton width='100%' height='32px' sx={{ mt: '16px' }} />
    ) : (
        <AgisticsMultiSelect
            label={L.roles()}
            items={createAgisticsSelectElements(allAvailableRoles, r => getTransUserRole(r).label)}
            selectedIds={roles?.map(r => r.id) || []}
            setSelectedIds={ids => onChange(allAvailableRoles.filter(r => ids.includes(r.id)))}
            required
            getOptionDisabled={isOptionDisabled}
        />
    );
};
